<template>
	<div class="form-grid">
		<slot />
	</div>
</template>

<script>
	export default {

	}
</script>

<style lang="scss">
	.form-grid > * {
		margin-bottom: 20px;
		padding: 20px 20px 0 20px;
		border-top: 1px solid #2d2f36;
	}

	.form-grid > *:last-child {
		margin-bottom: 0;
	}

	.form-grid > *:first-child {
		border-top: none;
	}

	.form-grid > * > * {
		margin-bottom: 20px;
	}

	.form-grid > * > *:last-child {
		margin-bottom: 0;
	}
</style>